/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/21/17
 * Copyright All Rights Reserved
 */
// @flow
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem } from 'reactstrap';
import SignOutLink from './SignOutLink';
import SP3Logo from 'components/support/logos/SP3Logo';
import {
  header,
  navItem,
  nav as headerNav,
  productAttribution,
  productName,
} from './Header.module.scss';

type Props = {
  inApp?: boolean,
  isAdmin?: boolean,
};

const NavDivider = () => <NavItem className={navItem}>|</NavItem>;

const Header = ({ inApp, isAdmin }: Props) => {
  const logo = inApp ? <SP3Logo /> : <Link to="sign-in"><SP3Logo /></Link>;
  const adminLink = isAdmin ?
    (
      <Fragment>
        <NavItem className={navItem}>
          <Link to="/admin">Admin</Link>
        </NavItem>
        <NavDivider />
      </Fragment>
    ) : null;

  const nav = inApp
    ? (
      <Nav className={headerNav}>
        {adminLink}
        <NavItem className={navItem}>
          <Link to="/inventory">Dashboard</Link>
        </NavItem>
        <NavDivider />
        <NavItem className={navItem}>
          <SignOutLink />
        </NavItem>
      </Nav>
    ) : (
      <Nav className={headerNav}>
        <NavItem className={navItem}>
          <Link to="/sign-in">Sign In</Link>
        </NavItem>
      </Nav>
    );

  return (
    <Navbar className={header} fixed="top">
      <Link to="/inventory">{logo}</Link>
      <span className={productName}> Portfolio</span>
      <span className={productAttribution}> by Haselton Baker Risk Group</span>
      {nav}
    </Navbar>
  );
};

Header.defaultProps = {
  inApp: true,
  isAdmin: false,
};

export default Header;



// WEBPACK FOOTER //
// ./js/components/support/layout/Header/Header.jsx